import { render, staticRenderFns } from "./feedBackDetail.vue?vue&type=template&id=3ff7892e&scoped=true"
import script from "./feedBackDetail.vue?vue&type=script&lang=js"
export * from "./feedBackDetail.vue?vue&type=script&lang=js"
import style0 from "./feedBackDetail.vue?vue&type=style&index=0&id=3ff7892e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7892e",
  null
  
)

export default component.exports